import { useEffect } from 'react';
import { useLocation, useMatch } from 'react-router';
import { useSelector } from 'react-redux';
import { t } from '../translations/t';
import { selectTranslationsLoading } from '../translations/slice';
/** Установить заголовок страницы в браузере */
export const useMetaTitles = (metaTitles, role) => {
    var _a;
    const { pathname } = useLocation();
    const translationLoadingStatus = useSelector(selectTranslationsLoading);
    const isTranslationsLoaded = translationLoadingStatus === 'complete';
    const sortedMetaTitles = [...metaTitles].sort((title1, title2) => title1.href.length - title2.href.length);
    const normalizePath = (path) => {
        if (path.startsWith('/personal')) {
            return '/personal';
        }
        return path;
    };
    const normalizedPathname = normalizePath(pathname);
    const findMatchingTitle = () => {
        const exactMatch = sortedMetaTitles.find((item) => normalizedPathname === item.href ||
            normalizedPathname === `/company${item.href}` ||
            normalizedPathname === `/employee${item.href}`);
        if (exactMatch)
            return exactMatch;
        return sortedMetaTitles.find((item) => {
            if (item.href === '/' || item.href === '') {
                return normalizedPathname === item.href;
            }
            else {
                return (normalizedPathname.startsWith(item.href) ||
                    normalizedPathname.startsWith(`/company${item.href}`) ||
                    normalizedPathname.startsWith(`/employee${item.href}`));
            }
        });
    };
    const { resource, parentResource, basename, submenu, href = 'not-found', completeTitle, } = findMatchingTitle() || {};
    const findedSubmenu = submenu &&
        submenu.find((item) => normalizedPathname === item.href ||
            normalizedPathname === `/company${item.href}` ||
            normalizedPathname === `/employee${item.href}`);
    const submenuTitle = findedSubmenu &&
        t(`modules.${(_a = findedSubmenu.parentResource) !== null && _a !== void 0 ? _a : findedSubmenu.resource}.${findedSubmenu.basename === 'sign-types'
            ? 'unep-types'
            : findedSubmenu.basename}.${role}Title`);
    const titleFromResource = submenuTitle ||
        ((resource && basename) || resource === 'Settings'
            ? t(`modules.${parentResource !== null && parentResource !== void 0 ? parentResource : resource}.${basename}.${role}Title`)
            : '');
    const titleWithSubmenu = isTranslationsLoaded ? titleFromResource : '';
    const title = completeTitle ? completeTitle[role] : titleWithSubmenu || '';
    const matchGeneral = useMatch(`${href}/*`);
    const employeeMatch = useMatch(`/employee${href}/*`);
    const companyMatch = useMatch(`/company${href}/*`);
    const match = matchGeneral || employeeMatch || companyMatch;
    useEffect(() => {
        var _a;
        document.title = [
            (_a = window.REACT_APP_VKHRTEK_META_TITLE_COMPANY) !== null && _a !== void 0 ? _a : 'VK HR Tek',
            match ? title : 'Страница не найдена',
        ]
            .filter((part) => part)
            .join(' - ');
    }, [pathname, title, href, match, role, metaTitles]);
};
